import { render, staticRenderFns } from "./InfosCommercial.vue?vue&type=template&id=46a4f0c2"
import script from "./InfosCommercial.vue?vue&type=script&lang=js"
export * from "./InfosCommercial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports